import Drift from 'drift-zoom';
import { registerInitializer } from "../shared/utils";

export const initializeMapMagnifier = () => {
  let drift = null;

  $('#mapModal').on('shown.bs.modal', function () {
    console.log('drift before check:', drift);

    if (drift) {
      drift.destroy();
      drift = null;
    }

    setTimeout(function () {
      const img = document.getElementById('modalMapImg');
      console.log('img:', img);
      console.log('data-zoom:', img ? img.getAttribute('data-zoom') : 'no img found');

      if (!img) return;
      
      drift = new Drift(img, {
        paneContainer: document.querySelector('#mapModal .modal-body'),
        inlinePane: false, 
        zoomFactor: 2.5,
        hoverBoundingBox: true,
        boundingBoxContainer: img,
      });

      img.dispatchEvent(new MouseEvent('mouseenter', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
      
      console.log('drift:', drift);
    }, 300);
  });

}; 

registerInitializer(initializeMapMagnifier);